module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjY2NjY0NzcgMHY1YzAgMi43NTcxNjYtMi4yNDI4MzQgNS01IDVWOC4zMzMzMjM4YzEuODM3OTU4NiAwIDMuMzMzMzIzOC0xLjQ5NTM2NTIgMy4zMzMzMjM4LTMuMzMzMzIzOEg2LjY2NjY0NzdWMGg1ek01IDB2NWMwIDIuNzU3MTY2LTIuMjQyODM0IDUtNSA1VjguMzMzMzIzOGMxLjgzNzk1ODYgMCAzLjMzMzMyMzgtMS40OTUzNjUyIDMuMzMzMzIzOC0zLjMzMzMyMzhIMFYwaDV6IiBmaWxsPSIjMTI2REFDIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9Ii4yMDA3OTk4NSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-quote-close.svg
// module id = b2w+
// module chunks = 2